var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('script',{attrs:{"id":"gb_widget_script","type":"module","src":_vm.widgetSrc,"data-skip-autostart":""},on:{"load":_vm.initWidget}})])}
var staticRenderFns = []

export { render, staticRenderFns }